import React from 'react';
import { Building, GraduationCap, HeartPulse } from 'lucide-react';

const Industries = () => {
  const iconMap = {
    'building': Building,
    'graduation-cap': GraduationCap,
    'heart-pulse': HeartPulse
  };

  const industries = [
    {
      id: 1,
      name: "Hospitality",
      description: "Hotels, resorts, restaurants, and travel services",
      projects: "150+ projects",
      icon: "building"
    },
    {
      id: 2,
      name: "Coaching",
      description: "Educational institutes, training centers, and online courses",
      projects: "200+ projects",
      icon: "graduation-cap"
    },
    {
      id: 3,
      name: "Healthcare",
      description: "Clinics, hospitals, wellness centers, and medical services",
      projects: "150+ projects",
      icon: "heart-pulse"
    }
  ];

  return (
    <section className="py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: "'Crimson Text', serif" }}>
            Industry Expertise
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Deep specialization across three high-growth verticals, delivering tailored strategies that work.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {industries.map((industry) => {
            const Icon = iconMap[industry.icon];
            return (
              <div 
                key={industry.id}
                className="bg-[#e6e67c] rounded-xl p-8 hover:shadow-xl transition-all duration-300 hover:translate-y-[-4px] border-2 border-transparent hover:border-black group"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-black rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-3xl font-bold mb-3" style={{ fontFamily: "'Crimson Text', serif" }}>
                  {industry.name}
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  {industry.description}
                </p>
                <p className="font-semibold text-black text-lg">
                  {industry.projects}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
